<template>
  <div
    class="anchorContainer scroller"
    ref="anchor"
    :style="getStyle"
    :class="{ hideScrollBarAutoScroll: !showAnchorScorll, nowrap: nowrap }"
    v-stick="{ positionType: 'sticky', stickyTop: 0 }"
  >
    <div class="anchorInner">
      <template v-if="options.styleType === 'horizontal'">
        <div
          v-for="(anchor, index) in anchorList"
          :key="index"
          ref="anchor"
          class="anchor"
          :class="activeIndex == index ? 'active' : ''"
          :style="{ ...sameStyle, ...getAnchorStyle(index) }"
          @mouseenter.stop.self="mouseoverEv(index)"
          @mouseleave.stop.self="mouseLeaveEv(index)"
        >
          <template>
            <div class="inline" v-if="getShowIcon && getIconPosition == 'left'">
              <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
              <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
            </div>
            <div v-if="getShowIcon && getIconPosition == 'top'">
              <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
              <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
            </div>
            <div class="anchor-name inline">
              <span v-if="contentHasLimitwords">
                {{ anchor.content.slice(0, textLimitLines) }}
                <span v-if="anchor.content.length > textLimitLines">...</span>
              </span>
              <span
                v-else
                :class="contentHasLimit && !contentHasLimitwords ? 'overflowHidMultiLines' : ''"
                :style="getTextLineLimit"
                >{{ anchor.content }}</span
              >
            </div>
            <div class="inline" v-if="getShowIcon && getIconPosition == 'right'">
              <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
              <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
            </div>
            <div v-if="getShowIcon && getIconPosition == 'bottom'">
              <cxTabsIcon v-if="iconType === 'icon' && iconSrc" :iconStyle="getIconStyle" :iconSrc="iconSrc"></cxTabsIcon>
              <img v-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
            </div>
            <!-- 分隔符 -->
            <div
              class="divide-box"
              v-if="index !== anchorList.length - 1 && options.showDivide"
              :style="getDivideStyle('img')"
            >
              <span class="line" :style="getDivideStyle('line')" v-if="options.divideType !== 'custom'"></span>
              <cxIcon
                class="icon"
                v-if="divideIconType === 'icon' && options.divideType === 'custom'"
                :options="options"
                :iconStyle="getDivideStyle('icon')"
                iconSrcName="divideIconSrc"
              ></cxIcon>
              <img
                class="icon"
                v-else-if="divideIconType === 'img' && divideIconSrc && options.divideType === 'custom'"
                :src="divideIconSrc"
                :style="getDivideStyle('img')"
              />
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <el-menu
          mode="vertical"
          :collapse="false"
          ref="navMenu"
          class="anchor-vertical vertical"
          :default-openeds="defaultOpeneds"
        >
          <template v-for="(anchor, index) in showAnchorList">
            <cx-menu-tree
              :key="index + ''"
              :items="anchor"
              :options="options"
              :index="index + ''"
              :root="true"
              @changePath="switchContent"
            />
          </template>
        </el-menu>
      </template>
    </div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import cxMenuTree from "./cxMenuTree.vue"
import { simpleDeepClone } from "../../../utils"
export default {
  mixins: [eventMixin],
  name: "cxAnchorComponent",
  components: { cxMenuTree },
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    //  获取当前操作的组件id
    ids() {
      return this.$store.state.states.activeID
    },
    anchorList() {
      return this.options.anchorList
    },
    showAnchorList() {
      let tempAnchorList = simpleDeepClone(this.options.anchorList)
      let travel = list => {
        for (let i = list.length - 1; i >= 0; i--) {
          if (list[i].hide) {
            list.splice(i, 1)
          } else {
            if (list[i].children && list[i].children.length > 0) {
              travel(list[i].children)
            }
          }
        }
      }
      travel(tempAnchorList)
      return tempAnchorList
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgColor() {
      return this.$parseColor(this.options.bgColor,{isThemeColor: this.options.bgColorIsThemeColor})
    },
    hoverBgColor() {
      return this.$parseColor(this.options.hoverBgColor,{isThemeColor: this.options.hoverBgColorIsThemeColor})
    },
    borderColor() {
      return this.$parseColor(this.options.borderColor,{isThemeColor: this.options.borderIsThemeColor})
    },
    hoverBorderColor() {
      return this.$parseColor(this.options.hoverBorderColor,{isThemeColor: this.options.hoverBorderIsThemeColor})
    },
    activeIndex() {
      return this.options.activeIndex
    },
    hoverIsSameActive() {
      return this.options.hasOwnProperty("hoverIsSameActive") ? this.options.hoverIsSameActive : true
    },
    hoverBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground =
        this.hoverIsSameActive || !this.options.hoverBackground
          ? this.options.activeBackground
          : this.options.hoverBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("hoverBgColorIsThemeColor")
              ? this.options.hoverBgColorIsThemeColor
              : false,
            color: this.options.hoverBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    activeStyle() {
      let borderW = ""
      if (Array.isArray(this.options.activeBorderWidth)) {
        this.options.activeBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.activeBorderWidth}px`
      }
      let activeBorderRadius = `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`
      if (this.options.hasOwnProperty("activeBorderTopLeftRadius")) {
        activeBorderRadius = `${this.options.activeBorderTopLeftRadius}px ${this.options.activeBorderTopRightRadius}px ${this.options.activeBorderBottomRightRadius}px ${this.options.activeBorderBottomLeftRadius}px`
      }
      let showActiveBorder = this.options.hasOwnProperty("showActiveBorder") ? this.options.showActiveBorder : true
      return {
        ...this.activeBgStyle,
        color: this.$parseColor(this.options.activeColor,{isThemeColor: this.options.activeTextIsThemeColor}),
        "font-size": this.options.activeFontSize + "px",
        "font-family": this.options.activeFontFamily || "",
        "font-weight": this.options.activeFontWeight,
        "text-align": this.options.hasOwnProperty("activeTextAlign")
          ? this.options.activeTextAlign
          : this.options.textAlign, // 为了兼容旧数据
        "font-style": this.options.activeFontStyle,
        "line-height":
          this.options.activeLineHeightType === "%"
            ? this.options.activeLineHeight + "%"
            : this.options.activeLineHeight + "px",
        "writing-mode": this.options.writingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent + "px",
        "border-color":  this.$parseColor(this.options.activeBorderColor),
        "border-style": this.options.activeBorderStyle,
        "border-width": !showActiveBorder ? 0 : borderW,
        "border-radius": activeBorderRadius
      }
    },
    activeBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.activeBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("activeBgColorIsThemeColor")
              ? this.options.activeBgColorIsThemeColor
              : false,
            color: this.options.activeBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    /* 悬浮样式 */
    hoverStyle() {
      if (this.hoverIsSameActive) return this.activeStyle
      let borderW = ""
      let hoverBorderWidth = this.options.hasOwnProperty("hoverBorderWidth")
        ? this.options.hoverBorderWidth
        : this.options.activeBorderWidth
      if (Array.isArray(hoverBorderWidth)) {
        hoverBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${hoverBorderWidth}px`
      }
      let hoverBorderRadius = `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`
      if (this.options.hasOwnProperty("activeBorderTopLeftRadius")) {
        hoverBorderRadius = `${this.options.activeBorderTopLeftRadius}px ${this.options.activeBorderTopRightRadius}px ${this.options.activeBorderBottomRightRadius}px ${this.options.activeBorderBottomLeftRadius}px`
      }
      if (this.options.hasOwnProperty("hoverBorderTopLeftRadius")) {
        hoverBorderRadius = `${this.options.hoverBorderTopLeftRadius}px ${this.options.hoverBorderTopRightRadius}px ${this.options.hoverBorderBottomRightRadius}px ${this.options.hoverBorderBottomLeftRadius}px`
      }
      let hoverLineHeight =
        this.options.hoverLineHeightType === "%"
          ? this.options.hoverLineHeight + "%"
          : this.options.hoverLineHeight + "px"
      if (this.options.hasOwnProperty("hoverLineHeight")) {
        hoverLineHeight =
          this.options.hoverLineHeightType === "%"
            ? this.options.hoverLineHeight + "%"
            : this.options.hoverLineHeight + "px"
      }
      let hoverBorderColor = this.$parseColor(this.hoverBorderColor)
      if (this.options.hasOwnProperty("hoverBorderColor")) {
        hoverBorderColor =
            this.$parseColor(this.options.hoverBorderColor,{isThemeColor:this.options.hoverBorderIsThemeColor })
      }
      let showHoverBorder = this.options.hasOwnProperty("showHoverBorder") ? this.options.showHoverBorder : true
      let colorSet =  this.options.hoverColor?  this.options.hoverColor :  this.options.activeColor
      return {
        ...this.hoverBgStyle,
        color: this.$parseColor(colorSet,{ isThemeColor: this.options.hoverTextIsThemeColor}),
        // color: this.options.hoverTextIsThemeColor
        //   ? this.themeColor : this.options.hoverColor ? this.options.hoverColor.color ? this.options.hoverColor.color : this.options.hoverColor : this.options.activeColor,
        "font-size": (this.options.hoverFontSize || this.options.activeFontSize) + "px",
        "font-family": this.options.hoverFontFamily || this.options.activeFontFamily || "",
        "font-weight": this.options.hoverFontWeight || this.options.activeFontWeight,
        "text-align": this.options.hoverTextAlign || this.options.textAlign,
        "font-style": this.options.hoverFontStyle || this.options.activeFontStyle,
        "line-height": hoverLineHeight,
        "writing-mode": this.options.hoverWritingMode || this.options.activeWritingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent + "px",
        "border-color": hoverBorderColor,
        "border-style": this.options.hoverBorderStyle || this.options.activeBorderStyle,
        "border-width": !showHoverBorder ? "0px" : borderW,
        "border-radius": hoverBorderRadius
      }
    },
    defaultBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.defaultBackground
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    defaultStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else if (this.options.borderWidth) {
        borderW += ` ${this.options.borderWidth}px`
      } else {
        borderW = "0px"
      }
      let showBorder = this.options.hasOwnProperty("showBorder") ? this.options.showBorder : true
      return {
        ...this.defaultBgStyle,
        color: this.$parseColor(this.options.color, {isThemeColor: this.options.textIsThemeColor}),
        "font-size": this.options.fontSize + "px",
        "font-family": this.options.fontFamily || "",
        "font-weight": this.options.fontWeight,
        "text-align": this.options.textAlign,
        "font-style": this.options.fontStyle,
        "line-height":
          this.options.lineHeightType === "%" ? this.options.lineHeight + "%" : this.options.lineHeight + "px",
        "writing-mode": this.options.writingMode,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        "text-indent": this.options.textIndent + "px",
        "border-radius": `${this.options.borderTopLeftRadius}px ${this.options.borderTopRightRadius}px ${this.options.borderBottomRightRadius}px ${this.options.borderBottomLeftRadius}px`,
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.borderColor),
        "border-width": !showBorder ? 0 : borderW
      }
    },
    getAnchorize() {
      let width = ""
      let widthUnit = ""
      let height = ""
      let heightUnit = ""
      const anchorWidthType = this.options.anchorWidthType
      switch (anchorWidthType) {
        case "px":
          width = this.options.anchorWidth
          widthUnit = "px"
          break
        case "自动":
          width = "auto"
          widthUnit = ""
          break
        case "%":
          width = 100
          widthUnit = "%"
          break
        default:
      }
      const anchorHeightType = this.options.anchorHeightType
      switch (anchorHeightType) {
        case "px":
          height = this.options.anchorHeight
          heightUnit = "px"
          break
        case "自动":
          height = "auto"
          heightUnit = ""
          break
        case "%":
          height = 100
          heightUnit = "%"
          break
        default:
      }
      return {
        width: width + widthUnit,
        height: height + heightUnit,
        flex: anchorWidthType == "%" ? 1 : ""
      }
    },
    sameStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.defaultBoxShadowH)) {
        this.options.defaultBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${this.options.defaultBoxShadowH[index]}px ${this.options.defaultBoxShadowV[index]}px ${this.options.defaultBoxShadowBlur[index]}px ${this.options.defaultBoxShadowSpread[index]}px ${this.$parseColor(this.options.defaultBoxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.defaultBoxShadowH}px ${this.options.defaultBoxShadowV}px ${this.options.defaultBoxShadowBlur}px ${this.options.defaultBoxShadowSpread}px ${this.$parseColor(this.options.defaultBoxShadowColor)}`
      }
      const divideWidth = this.options.divideWidth || 1
      let divideMargin = 0
      if (this.options.marginRight !== undefined) divideMargin = -(this.options.marginRight + divideWidth) / 2
      return {
        ...this.getAnchorize,
        opacity: this.options.hasOwnProperty("anchorOpacity") ? this.options.anchorOpacity / 100 : 1,
        padding: this.getPaddingStyle,
        "margin-right": this.options.marginRight + "px",
        "margin-bottom": this.options.marginBottom + "px",
        boxShadow: tmpStyle,
        "--divideMargin": divideMargin + "px"
      }
    },
    getAnchorStyle() {
      return function (index) {
        if (index == this.activeIndex) {
          return this.activeStyle
        } else if (index == this.hoverIndex) {
          return this.hoverStyle
        } else {
          return this.defaultStyle
        }
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("allBgColorIsThemeColor")
              ? this.options.allBgColorIsThemeColor
              : false,
            color: this.options.allBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            // let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            // let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle +=
              `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle +=
            `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getStyle() {
      let borderW = ""
      if (Array.isArray(this.options.allBorderWidth)) {
        this.options.allBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.allBorderWidth}px`
      }
      let padding = `${this.options.ulPadding}px`
      if (this.options.ulPaddingTypeFlag === 2) {
        padding = ` ${this.options.ulPaddingTop}px  ${this.options.ulPaddingRight}px  ${this.options.ulPaddingBottom}px  ${this.options.ulPaddingLeft}px`
      }
      let showAllBorder = this.options.hasOwnProperty("showAllBorder") ? this.options.showAllBorder : true
      return {
        ...this.bgStyle,
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.allBorderTopLeftRadius + "px",
        "border-top-right-radius": this.options.allBorderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.allBorderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.allBorderBottomLeftRadius + "px",
        "border-style": this.options.allBorderStyle,
        "border-color": this.$parseColor(this.options.allBorderColor),
        "border-width": !showAllBorder ? "0px" : borderW,
        display: this.showAnchorScorll || this.options.anchorWidthType === "%" ? "flex" : "",
        "overflow-y": this.showAnchorScorll ? "hidden" : "",
        "overflow-x": this.showAnchorScorll ? "auto" : "",
        padding: padding
      }
    },
    textLimitLines() {
      return this.options.textLimitLines
    },
    contentHasLimit() {
      return this.options.contentHasLimit
    },
    textLimitWords() {
      return this.options.textLimitWords || 1
    },
    // 判断是否按字数限制
    contentHasLimitwords() {
      return this.contentHasLimit && (this.options.contentHasLimitRadio == "字数" || !this.options.contentHasLimitRadio)
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition || "left" : "left"
    },
    getShowIcon() {
      return this.options ? this.options.showIcon : "false"
    },
    getMargin() {
      const iconPosition = this.options.iconPosition ? this.options.iconPosition : "left"
      return iconPosition === "right"
        ? `0 0 0 ${this.options.iconMargin}px`
        : iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : iconPosition === "top"
        ? `0 0 ${this.options.iconMargin}px 0`
        : iconPosition === "bottom"
        ? `${this.options.iconMargin}px 0 0 0`
        : "0 0 0 0"
    },
    getIconStyle() {
      return {
        display: "inline-block",
        "--color": this.$parseColor(this.options.iconColor,{isThemeColor: this.options.iconColorIsThemeColor}),
        width: this.options.hasOwnProperty("iconWidth") ? this.options.iconWidth + "px" : "14px",
        height: this.options.hasOwnProperty("iconHeight") ? this.options.iconHeight + "px" : "14px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.hasOwnProperty("iconWidth") ? this.options.iconWidth + "px" : "14px",
        height: this.options.hasOwnProperty("iconHeight") ? this.options.iconHeight + "px" : "14px",
        margin: this.getMargin
      }
    },
    showAnchorScorll() {
      return this.options.hasOwnProperty("showAnchorScorll") ? this.options.showAnchorScorll : false
    },
    divideIconSrc() {
      return this.options ? this.options.divideIconSrc : ""
    },
    divideIconType() {
      return this.options ? this.options.divideIconType : "icon"
    },
    getDivideStyle() {
      return function (type) {
        let style = {}
        const color = this.$parseColor(this.options.divideIconColor,{isThemeColor: this.options.divideIconColorIsThemeColor})
        const width = this.options.divideWidth || 1
        const height = this.options.divideHeight || 24
        style = {
          width: width + "px",
          height: height + "px"
        }
        switch (type) {
          case "line":
            style = {
              ...style,
              backgroundColor: color
            }
            break
          case "icon":
            style = {
              ...style,
              "--color": color
            }
            break
          case "img":
            break
        }
        return style
      }
    },
    nowrap() {
      // 开启自适应并且没有最大宽度时不允许换行
      const widthAuto = this.options?.anchorWidth === "auto" || this.options?.widthAuto
      return widthAuto && !(this.options?.showAnchorMaxWidth && this.options?.anchorMaxWidth)
    },
    getTextLineLimit() {
      if (this.contentHasLimit && !this.contentHasLimitwords) {
        return {
          "-webkit-line-clamp": this.textLimitWords
        }
      } else return {}
    },
    defaultOpeneds() {
      let arr = []
      let travel = (items, key) => {
        items.forEach((item, index) => {
          if (item.children && item.children.length > 0) {
            let newKey = key ? `${key}_${index}` : `${index}`
            arr.push(newKey)
            travel(item.children, newKey)
          }
        })
      }
      travel(this.showAnchorList)
      return arr
    }
  },
  data() {
    return {
      hoverIndex: undefined,
      animateReloadTimer: null, // 用于动画更新
      anchorWidthList: []
    }
  },
  created() {
    this.$changeOptionsEV("0", "activeIndex", false, this.myid, false, true)
  },
  mounted() {
    this.scrollWrap = document.querySelector("#pageScollbar .el-scrollbar__wrap")
    this.scrollWrap.addEventListener("scroll", this.computeAnchorStatus)
    this.$initPlugin(this.options?.pluginName)
    if (this.options.noteEditorAnchor) {
      this.$changeOptionsEV([], "anchorList", false, this.myid, false, true)
      let timer = setInterval(() => {
        const note = document.querySelector(".multieditor")
        if (note) {
          clearInterval(timer)
          // 等500ms，笔记本编辑器渲染
          setTimeout(() => {
            this.initMultiEditorMenu()
          }, 1000)
        }
      }, 200)
    } else if (this.options.fullScrollAnchor) {
      this.initFullPageMenu()
    } else {
      setTimeout(() => {
        this.$eventBus.$emit("set-anchorId", this.anchorList)
      }, 1000)
    }
    this.$eventBus.$on("update-subPage-anchor-data", this.updateDetailPageData)
  },
  beforeDestroy() {
    this.scrollWrap.removeEventListener("scroll", this.computeAnchorStatus)
    this.scrollWrap = null
    this.$eventBus.$off("update-subPage-anchor-data", this.updateDetailPageData)
  },
  destroyed() {
    clearInterval(this.animateReloadTimer)
    this.animateReloadTimer = null
  },
  methods: {
    updateDetailPageData() {
      if (this.options.noteEditorAnchor) {
        this.initMultiEditorMenu()
        this.$changeOptionsEV("0", "activeIndex", false, this.myid, false, true)
      }
    },
    initMultiEditorMenu() {
      const list = []
      let multieditor = document.querySelectorAll(".multieditor h1, .multieditor h2, .multieditor h3, .multieditor h4")
      if (multieditor.length > 0) {
        for (let i = 0; i < multieditor.length; i++) {
          let curDom = multieditor[i]
          list.push({
            tagName: curDom.tagName,
            target: curDom.getAttribute("element-id"),
            content: curDom.innerText,
            hide: false
          })
        }
      }
      let anchorList = this.convertToTree(list)
      this.$changeOptionsEV(anchorList, "anchorList", false, this.myid, false, true)
    },
    convertToTree(arr) {
      const root = {
        children: []
      }
      const stack = [root]
      arr.forEach(item => {
        const level = parseInt(item.tagName.substring(1))
        const node = {
          ...item,
          children: []
        }
        // 如果当前节点的层级小于等于栈顶节点的层级
        // 则需要回溯到合适的父节点
        while (stack.length > 1 && parseInt(stack[stack.length - 1].tagName?.substring(1) || 0) >= level) {
          stack.pop()
        }
        stack[stack.length - 1].children.push(node)
        stack.push(node)
      })
      return root.children
    },
    mouseoverEv(index) {
      this.hoverIndex = index
    },
    mouseLeaveEv(index) {
      this.hoverIndex = undefined
    },
    currentItem(index) {
      index = index + ""
      let arr = index.split("_")
      let obj = this.anchorList
      let child = this.anchorList
      while (arr.length > 0) {
        let idx = arr.shift()
        obj = child[idx]
        child = obj.children
      }
      return obj
    },
    switchContent(path) {
      if (!this.showAnchorList.length) {
        return
      }
      this.$changeOptionsEV(`${path}`, "activeIndex", false, this.myid, false, true)
    },
    computeAnchorStatus() {
      const anchorItems = document.querySelectorAll(".anchor-item")
      let path = "0"
      for (let i = 0; i < anchorItems.length; i++) {
        const rect = anchorItems[i].getBoundingClientRect()
        let itemTop = rect.top || 0
        let itemBottom = rect.bottom || 0
        const showRuler = !this.$store.state.states.showRuler
        const headHeight = showRuler ? 74 : 50
        itemTop -= headHeight
        itemBottom -= headHeight
        if (itemTop <= 0 && itemBottom >= 0) {
          path = anchorItems[i].getAttribute("data-path")
          break
        } else if (itemBottom < 0) {
          path = anchorItems[i].getAttribute("data-path")
        }
      }
      this.switchContent(path)
    },
    initFullPageMenu() {
      const showMap = {}
      this.anchorList.forEach(item => {
        showMap[item.target] = item.hide
      })
      const newAnchor = this.initFullScrollMenu()
      // 获取最新的整屏切换锚点，并且将历史设置过的显隐还原
      newAnchor.forEach(item => {
        if (showMap.hasOwnProperty(item.target)) {
          item.hide = showMap[item.target]
        }
      })
      this.$changeOptionsEV(newAnchor, "anchorList", false, this.myid, false, true)
    },
    initFullScrollMenu() {
      let anchorList = []
      const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageAnchor = pageLayoutList.find(item => item.options.inDocument === "anchor" && item.options.isShow)
      if (!pageAnchor) {
        anchorList = []
        return anchorList
      }
      if (pageAnchor.options.isNewAnchor) {
        anchorList = pageAnchor.options.anchorData
          .filter(item => item.fullSwitchType === "toAssignedPage" && item.anchorShow)
          .map(item => ({
            content: item.content,
            target: item.fullSwitchPage,
            switchType: item.fullSwitchType,
            hide: false,
            children: []
          }))
      }
      return anchorList
    }
  }
}
</script>

<style lang="scss" scoped>
.anchorContainer {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;
  &.scroller::-webkit-scrollbar {
    display: block;
  }
  &.scroller.hideScrollBarAutoScroll::-webkit-scrollbar {
    display: none;
  }
  .hideScrollBarAutoScroll {
    white-space: nowrap;
    overflow-x: auto;
  }
  .anchor {
    position: relative;
    display: inline-block;
    vertical-align: top;
    &:last-child {
      margin-right: 0 !important;
    }
    .anchor-underline {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .divide-box {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: var(--divideMargin);
  }
  .divide-box .line,
  .divide-box .icon {
    display: block;
  }
  .anchorInner {
    width: 100%;
    height: 100%;
    display: flex;
  }
}
::v-deep svg {
  vertical-align: middle;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.vertical-middle {
  vertical-align: middle;
  line-height: 1;
  font-size: 0;
}
/* 文本内容不允许换行 */
.nowrap .anchor .anchor-name > span {
  white-space: nowrap;
}
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
<style lang="scss">
.anchor-vertical.vertical {
  height: 100%;
  overflow-y: auto;
  border-right: 0;
}
.anchor-vertical.vertical .el-menu {
  background: rgba(255, 255, 255, 0);
}
.anchor-vertical.vertical.el-menu::-webkit-scrollbar {
  width: 8px;
  height: 6px;
  display: block;
}
.anchor-vertical.vertical.el-menu::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  border-radius: 3px;
}

.anchor-vertical.vertical .el-submenu__title,
.anchor-vertical.vertical .el-menu-item {
  width: var(--itemWidth);
  height: var(--itemHeight);
  color: var(--color);
  font-size: var(--fontSize);
  font-family: var(--fontFamily);
  font-weight: var(--fontWeight);
  white-space: normal;
  line-height: var(--lineHeight);
  text-align: var(--textAlign);
  text-decoration: var(--textDecoration);
  letter-spacing: var(--letterSpacing);
  writing-mode: var(--writingMode);
  font-style: var(--fontStyle);
  border-width: var(--borderWidth);
  border-style: var(--borderStyle);
  border-color: var(--borderColor);
  box-shadow: var(--boxShadow);
  background-image: var(--backgroundImage);
  background-size: var(--backgroundSize);
  background-position: var(--backgroundPosition);
  background-repeat: var(--backgroundRepeat);
  background-color: var(--backgroundColor);
  border-radius: var(--borderRadius);
  padding: 0;
}

.anchor-vertical.vertical .is-active > .el-submenu__title .anchor-icon-default,
.anchor-vertical.vertical .el-menu-item.is-active .anchor-icon-default,
.anchor-vertical.vertical .el-submenu__title:hover .anchor-icon-default,
.anchor-vertical.vertical .el-menu-item:hover .anchor-icon-default {
  display: none;
}
.anchor-vertical.vertical .is-active > .el-submenu__title .anchor-icon-active,
.anchor-vertical.vertical .el-menu-item.is-active .anchor-icon-active,
.anchor-vertical.vertical .el-submenu__title:hover .anchor-icon-active,
.anchor-vertical.vertical .el-menu-item:hover .anchor-icon-active {
  display: inline-block;
}

/* 1级菜单 悬浮 */
.anchor-vertical.vertical .el-submenu__title:hover span,
.anchor-vertical.vertical .el-menu-item:hover span {
  color: var(--hoverColor) !important;
}
.anchor-vertical.vertical .el-submenu__title:hover,
.anchor-vertical.vertical .el-menu-item:hover {
  font-size: var(--hoverFontSize) !important;
  font-family: var(--hoverFontFamily) !important;
  font-weight: var(--hoverFontWeight) !important;
  line-height: var(--hoverLineHeight);
  text-align: var(--hoverTextAlign);
  text-decoration: var(--hoverTextDecoration);
  letter-spacing: var(--hoverLetterSpacing);
  writing-mode: var(--hoverWritingMode);
  font-style: var(--hoverFontStyle);
  border-width: var(--hoverBorderWidth);
  border-style: var(--hoverBorderStyle);
  border-color: var(--hoverBorderColor) !important;
  border-radius: var(--hoverBorderRadius);
  background: var(--hoverBackground) !important;
  background-image: var(--hoverBackgroundImage) !important;
  background-size: var(--hoverBackgroundSize) !important;
  background-position: var(--hoverBackgroundPosition) !important;
  background-repeat: var(--hoverBackgroundRepeat) !important;
  background-color: var(--hoverBackgroundColor) !important;
}

/* 图标 */
.anchor-vertical.vertical .el-submenu__title > .icon {
  display: inline-block;
}
.anchor-vertical.vertical .el-submenu__title > .right-icon {
  transform: translateY(-50%);
}
/* 展开后  图标 */
.anchor-vertical.vertical .el-submenu.is-opened > .el-submenu__title > .right-icon {
  transform: rotate(180deg) translateY(50%);
}
.anchor-vertical.vertical .el-submenu.is-opened > .el-submenu__title > .left-icon {
  transform: rotate(180deg);
}
.anchor-vertical.vertical.el-menu--collapse .el-menu .el-submenu,
.anchor-vertical.vertical .el-submenu .el-menu-item {
  min-width: 10px !important;
}

/* 1级菜单 选中 */
.anchor-vertical.vertical .is-active > .el-submenu__title span,
.anchor-vertical.vertical .el-menu-item.is-active span {
  color: var(--activeColor) !important;
}
.anchor-vertical.vertical .is-active > .el-submenu__title,
.anchor-vertical.vertical .el-menu-item.is-active {
  border-width: var(--activeBorderWidth);
  border-style: var(--activeBorderStyle);
  border-color: var(--activeBorderColor) !important;
  border-radius: var(--activeBorderRadius);
  line-height: var(--activeLineHeight);
  text-align: var(--activeTextAlign);
  text-decoration: var(--activeTextDecoration);
  letter-spacing: var(--activeLetterSpacing);
  writing-mode: var(--activeWritingMode);
  font-style: var(--activeFontStyle);
  font-size: var(--activeFontSize) !important;
  font-family: var(--activeFontFamily) !important;
  font-weight: var(--activeFontWeight) !important;
  background: var(--activeBackgroundColor) !important;
  background-image: var(--activeBackgroundImage) !important;
  background-size: var(--activeBackgroundSize) !important;
  background-position: var(--activeBackgroundPosition) !important;
  background-repeat: var(--activeBackgroundRepeat) !important;
  background-color: var(--activeBackgroundColor) !important;
}
.anchor-vertical.vertical .el-submenu .el-submenu > .el-submenu__title span,
.anchor-vertical.vertical .el-submenu .el-menu-item span {
  max-width: 100%;
  white-space: normal;
}

.anchor-vertical.vertical .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
.anchor-vertical.vertical.el-menu {
  background-color: transparent;
  width: 100%;
}

.anchor-vertical.vertical .el-submenu__title svg {
  vertical-align: middle;
  width: 100%;
  height: 100%;
}
.anchor-vertical.vertical .el-submenu__title svg * {
  stroke: var(--color);
}
.anchor-vertical.vertical .el-submenu {
  background: transparent !important;
}
.anchor-vertical.vertical .el-menu--inline.el-menu {
  width: var(--itemWidth);
}

/* 缩进样式 */
.anchor-vertical.vertical > .el-submenu > .el-submenu__title,
.anchor-vertical.vertical > .el-menu-item {
  padding-left: var(--leftIndent) !important;
  padding-right: 0;
}
.anchor-vertical.vertical > .el-submenu > .el-menu > .el-submenu > .el-submenu__title,
.anchor-vertical.vertical > .el-submenu > .el-menu > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 2) !important;
}
.anchor-vertical.vertical > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-submenu > .el-submenu__title,
.anchor-vertical.vertical > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 3) !important;
}
.anchor-vertical.vertical
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-submenu__title,
.anchor-vertical.vertical > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 4) !important;
}
.anchor-vertical.vertical
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-submenu__title,
.anchor-vertical.vertical
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-submenu
  > .el-menu
  > .el-menu-item {
  padding-left: calc(var(--leftIndent) * 5) !important;
}
.anchor-vertical.vertical .data-icon {
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  width: 12px;
}
</style>
